/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

// Window Load
$(window).on('load', function () {
    // UPPERCASE INITIALS
 });

// DOM READY
  $(document).ready(function() {
    
  }); // End DOM Ready

(function() {
  // Add custom code below this line
  
  // Wait for IO to load
  window.Shoppad = window.Shoppad || {},
    window.Shoppad.apps = window.Shoppad.apps || {},
    window.Shoppad.apps.infiniteoptions = window.Shoppad.apps.infiniteoptions || {},
    window.Shoppad.apps.infiniteoptions.ready = function() {

        // FORCER UPPERCASE INITIALS
          $("input#INITIALS-0-0").keyup(function () {
            $(this).val($(this).val().toUpperCase());  
            console.log('uppercase');
          });
            
          $("#infiniteoptions-container").detach().appendTo('.product__selectors #MONOGRAMwrap');
          
          // Look on load (incase the monogram is auto selected)
          if ($('.MONOGRAMwrap input:checked').val() == 'NO' || $('label:contains("MONOGRAM")').next().val() == 'NO' ) {
              $('#infiniteoptions-container').fadeOut(); // HIDE
            } else {
              $('#infiniteoptions-container').fadeIn(); // REVEAL
            }
          
          $('.MONOGRAMwrap input').change(function() {
            if ($('.MONOGRAMwrap input:checked').val() == 'NO' || $('label:contains("MONOGRAM")').next().val() == 'NO' ) {
              $('#infiniteoptions-container').fadeOut(); // HIDE
            } else {
              $('#infiniteoptions-container').fadeIn(); // REVEAL
            }
          });
    }; // END IO Scripts

  //Target BLANK on Download / Playlists
  
  $("a.btn:contains('download')").attr('target','_blank');
  $("a.btn:contains('PLAY NOW')").attr('target','_blank');


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
